import { useMemo } from 'react';
import { useAppStore } from '../store/useAppStore';
import { useSettingsStore } from '../store/useSettingsStore';
import { getCustomerOrders } from '../utils/orderUtils';

// Memoized own orders for the current customer — avoids re-scanning the full
// order list on every render (and per customer card).
export function useCustomerOrders() {
  const orders = useAppStore((state) => state.orders);
  const currentCustomer = useSettingsStore((state) => state.currentCustomer);

  return useMemo(() => getCustomerOrders(orders, currentCustomer), [orders, currentCustomer]);
}
